import { formatDate } from "@angular/common";

export const transformDate = (date = new Date()): string => {
  return formatDate(date, "dd/MM/yyyy", "pt");
};
